import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useUIMode } from "../hooks/useUIMode";
import { UserContext } from "../UserContext";
import { hasAnyPerm } from '../utils/uiUtils';
import { useTranslation } from 'react-i18next';
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import TemplateListView from "./TemplateListView";
import DatasourceAdminDetailsView from "./DatasourceAdminDetailsView";
import DatasourceAdminNewView     from "./DatasourceAdminNewView";


const DatasourceAdmin = () => {

  const { t }    = useTranslation(["common"]);
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const { uiMode, setUIMode, objDetails, setObjDetails } = useUIMode('LIST');

  const PAGE_STATE_STORAGE_KEY = "DatasourceAdmin.pageState";
  const defaultPageState = {
    searchTerms: null,
    sortCol: null,
    sortDir: null,
    perPage: 25,
    currPage: 1
  };

  const [pageState, setPageState] = useState(() => {
    try {
      const savedPageState = sessionStorage.getItem(PAGE_STATE_STORAGE_KEY);
      return savedPageState
        ? { ...defaultPageState, ...JSON.parse(savedPageState) }
        : defaultPageState;
    } catch (error) {
      return defaultPageState;
    }
  });

  useEffect(() => {
    sessionStorage.setItem(PAGE_STATE_STORAGE_KEY, JSON.stringify(pageState));
  }, [pageState]);

  // Initialize state
  useEffect(() => {

    // Route to home page if not authorized
    if (!hasAnyPerm(user, ["BuildingAdminGeneralWriteAccess"], true)) {
      navigate("/AdminHome/Dashboard", {
        state: {
          //...values
          target: 'Dashboard'
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // ----- Data Table stuff -----

  const tableColumns = [
    {
      igcColumnType: 'PRIMARY_ID',
      igcFieldName: 'code',
      name: t("I18N_Datasource_code"),
      sortable: true,
      sortField: 'code',
      cell: null
    },
    {
      name: t("I18N_Name"),
      selector: row => row.name,
      sortable: true,
      sortField: 'name',
      grow: 1,
      wrap: true
    },
    {
      name: t("I18N_Description"),
      selector: row => row.description,
      grow: 2,
      wrap: true
    },
    {
      name: t("I18N_Vendor"),
      selector: row => row.vendor,
      sortable: true,
      sortField: 'vendor',
      wrap: true
    },
    {
      name: t("I18N_API_name"),
      selector: row => row.apiName,
      sortable: true,
      sortField: 'apiName',
      wrap: true
    },
    {
      name: t("I18N_API_type"),
      selector: row => row.apiType,
      sortable: true,
      sortField: 'apiType',
      wrap: true
    },
    {
      igcColumnType: 'DELETE',
      name: '',
      selector: row => row.id,
      grow: 0.5,
      cell: null
    }
  ];

  // ----- END - Data Table stuff -----


  return (
    <Fragment>

      {(uiMode === 'LIST')    ? <TemplateListView pageState={pageState}
                                                  axiosAPI={axiosAuth_DATA_MGMT_API}
                                                  apiObjName={'datasources'}
                                                  listPageTitle={t("I18N_Datasource_Mgmt")}
                                                  newObjTooltip={t("I18N_TIP_New_datasource")}
                                                  searchTooltip={t("I18N_Search")}
                                                  deleteConfirmDialogTitle={t("I18N_Datasource_del_confirm")}
                                                  deleteObjTooltip={t("I18N_TIP_Delete_entry")}
                                                  tableColumns={tableColumns}
                                                  deletePermission={'BuildingAdminGeneralDeleteAccess'}
                                                  onUIMode={setUIMode}
                                                  onSetPageState={setPageState}
                                                  onSetObjDetails={setObjDetails} /> : null}
      {(uiMode === 'DETAILS') ? <DatasourceAdminDetailsView onUIMode={setUIMode} objDetails={objDetails} />                  : null}
      {(uiMode === 'NEW')     ? <DatasourceAdminNewView     onUIMode={setUIMode} />                                          : null}

    </Fragment>
  )
}

export default DatasourceAdmin;
